import { Formatter, navigationWeb, useSelector } from 'gf-ui';
import React, { useEffect, useRef } from 'react';
import { FaHome, FaSearch } from 'react-icons/fa';
import { FaListCheck } from 'react-icons/fa6';
import { useDispatch } from 'react-redux';
import { API_SERVICES } from '..';
import QHome from '../../libQuestionario/pages/QHome';
import MRHeader from './components/MRHeader';
import { Link } from 'react-router-dom'

const MRHome = () => {
  const pageData = useSelector(state => state.page.data)
  const dispatch = useDispatch()
  const shouldInit = useRef(true)

  useEffect(() => {
    if (shouldInit.current) {
      shouldInit.current = false
      const navItems = [
        { label: "Home", icon: <FaHome />, route: "/", active: "/" },
        { label: "Questionari", icon: <FaListCheck />, route: API_SERVICES.MR.HOME_ROUTE, active: API_SERVICES.MR.HOME_ROUTE }
      ];

      if(Formatter.getBoolean(pageData.MOSTRA_LINK_CERCA_MR)){
        navItems.push({ label: "Cerca Malattie Rare", icon: <FaSearch />, route: "/malattie-rare/cerca", active: "/malattie-rare/cerca" })
      }

      navigationWeb(dispatch, navItems);        
    }
  }, [dispatch, pageData?.MOSTRA_LINK_CERCA_MR])

  return <QHome
    homeRoute={API_SERVICES.MR.HOME_ROUTE}
    root={API_SERVICES.MR.ROOT}
    title={API_SERVICES.MR.NOME}
    headerComponent={<MRHeader label={pageData.SERVIZI_ABILITATI.find(s => s.CODICE === API_SERVICES.MR.CODICE).DESCRIZIONE} />}
    bodyHeader={Formatter.getBoolean(pageData.MOSTRA_LINK_CERCA_MR) ? <div className='w-100 mb-4 d-flex flex-row align-items-center justify-content-center'><FaSearch className='me-2' /><Link to="/malattie-rare/cerca">Cerca Malattie rare</Link></div> : null}
  />
}
export default MRHome;